/**
 * Created by lobin on 2018/8/28.
 */
import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import routes from './routes'
import nprogress from 'nprogress'
nprogress.configure({ trickle: true, easing: 'ease', speed: 500 });
const router = new Router({
	mode: 'history',
	routes: [
    	{
			path: '/',
			name: 'default',
			redirect: { path: '/home' }
		},
		{
			path:'/login',
			name:'login',
			component: () => import('../views/login.vue')
		},
		{
			path:'/print',
			name:'print',
			component: () => import('../views/print/print.vue')
		},
		...routes
	]
})
/**
 * 路由拦截
 * 权限验证
 */
router.beforeEach((to, from, next) => {
	nprogress.start();
	// 验证当前路由所有的匹配中是否需要有登陆验证的
	if (to.matched.some(r => r.meta.requiresAuth)) {
		// 请根据自身业务需要修改
		const token = window.localStorage.getItem('token');
		if (token && token !== 'undefined') {
			next()
		} else {
			// 没有登陆的时候跳转到登陆界面
			next({
				name: 'login'
			})
		}
	} else {
		// 不需要身份校验 直接通过
		next()
	}
})

router.afterEach(to => {
	const app = router.app
	const { name, params, query } = to
	nprogress.done();
})

export default router

